module.exports = __webpack_public_path__ + "img/delete.00c1acf9.svg";